export default __webpack_public_path__ + "static/media/FHAM.4343cfa5.png";